export function cardSurfaceClass(surface: unknown): string {
  const tone = String(surface ?? "theme");
  if (tone === "dark") {
    return "border-slate-800 bg-slate-950 text-slate-100";
  }
  if (tone === "muted") {
    return "border-[var(--color-border)] bg-[var(--color-surface-muted)]";
  }
  return "";
}

export function cardHeadingClass(surface: unknown): string {
  return String(surface ?? "theme") === "dark" ? "text-slate-100" : "text-[var(--color-text)]";
}

export function cardBodyClass(surface: unknown): string {
  return String(surface ?? "theme") === "dark" ? "text-slate-300" : "text-[var(--color-secondary)]";
}
